import API from '../common/API';

const getAvailableDates = async (eventName) => await API.get({
    endpoint: `/api/v1/seminar/${eventName}/available_dates/`,
});

export default {
    getAvailableDates,
};
